import * as React from 'react';
import { useBondsBondIsRedacted, useBondsBondSAccOblFirstCps } from '../../hooks';
import { ActorApiDateDisplay } from '../../../../../../components/display/date';

export const BondsBondSAccOblFirstCps = (props: {
  withRedactedIcon?: boolean,
}) => {
  const {
    withRedactedIcon,
  } = props;
  const {
    data,
    isLoading,
    error,
  } = useBondsBondSAccOblFirstCps();
  const {
    data: redacted,
    isLoading: redactedIsLoading,
  } = useBondsBondIsRedacted('S_ACC.OBL_FIRST_CPS');
  return (
    <ActorApiDateDisplay
      data={data}
      isLoading={isLoading || redactedIsLoading}
      error={error}
      formatMq={false}
      isBlocked={redacted}
      withRedactedIcon={withRedactedIcon}
    />
  );
};
